function useEmployeeSalaryLateEarltDeduct() {
  return {};
}

export default useEmployeeSalaryLateEarltDeduct;
